<template>
  <!-- 专业类别设置 -->
    <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <!-- 非普本类专业 -->
  <el-button-group v-if ="false">
    <el-button type="primary" size="large" @click="addFnc($event)"
      ><el-icon><Plus /></el-icon>添加学历类专业</el-button
    >
  </el-button-group>
  <!-- 表格组件 -->
  <TableList
    componentTableId="NotPbMajor"
    @update-list="updateList"
    excelName="非普本类专业"
    :table-data="tableData"
    :header-data="headerData"
    :distributionIsShow="btnLeftList.length > 0"
    :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @deleteFnc="deleteFnc"
    @searchFnc="searchFnc"
    @openContent="openContent"
    @handleSelection="handleSelection"
  >
  <!-- 列表按钮操作动态 -->
   <template #inTableCustom="scope">
     <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
       <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
         <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
           :disabled="!item.tip">
           <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
             :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
         </el-tooltip>
       </el-button-group>
       <div v-else>
         <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
           :disabled="!item.tip">
           <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
             :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
         </el-tooltip>
       </div>
     </div>
   </template>
    <template #nameCustom="scope">
      <span class="hand blue" @click="openCourseDetail(scope.scope)">{{
        scope.scope.name
      }}</span>
    </template>
  </TableList>
   <!-- 打开前台移动端 -->
   <el-dialog
        :close-on-click-modal="false"
        v-model="UrlOpenFlag"
        :title="selectTitle"
        width="400px"
        append-to-body="false"
        draggable
        destroy-on-close
      >
        <OpenMobile
          ref="UrlOpen"
          v-if="UrlOpenFlag"
          :url="mobileUrl"
          :studentDialogTitle="selectTitle"
        >
        </OpenMobile>
      </el-dialog>
  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  >
  </Pagination>
  <!-- 添加编辑 非普本类专业管理 -->
  <el-dialog
    class="dialogNoPadding"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="800px"
    draggable
    destroy-on-close
  >
    <AddEditNotPbMajor
      v-if="addEditVisible"
      :edit-id="editId"
      :category-sel="majorCategorySel"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditNotPbMajor>
  </el-dialog>
  <!-- 查看详情 弹窗 -->
  <el-dialog
    v-model="contentVisible"
    :title="contentdialogTitle"
    width="1000px"
    draggable
    destroy-on-close
  >
    <div
      class="contentDialog"
      v-html="contentDetails"
      v-if="contentVisible"
    ></div>
  </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import { reactive, onMounted, computed ,toRefs, ref, toRaw, h, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus, SUB_URL_Decode } from "common/utils";
import { getMajorPageList, delMajor } from "network/notPbMajor.js";
import { getMajorCategory } from "network/majorCategory.js";
import AddEditNotPbMajor from "views/notPbMajor/AddEditNotPbMajor.vue";
import OpenMobile from "components/OpenMobile"
import store from "../../store/index";
export default {
  name: "NotPbMajor",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddEditNotPbMajor,
    OpenMobile
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
       // 登录状态
       AdminCache: computed(() => {
        return (
          store.state.AdminCache ||
          JSON.parse(sessionStorage.getItem("AdminCache"))
        );
      }),
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      roleId:computed(() => store.state.AdminCache.roleId || sessionStorage.getItem("AdminCache").roleId),
      configRoleId:computed(() => store.state.AdminCache.configRoleId || sessionStorage.getItem("AdminCache").configRoleId),
      UrlOpenFlag: false, //打开前台移动端
      mobileUrl: "", // 跳转前台移动端url
      selectTitle: "",
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      multipleSelection:[],
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },
        {
          label: "专业名称",
          prop: "name",
          width: "200",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
          custom: true,
        },
        {
          label: "所属专业类别",
          prop: "majorCategoryName",
          width: "200",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
          majorCategoryName:null,
        },
        {
          label: "院校类别",
          prop: "categoryName",
          width: "160",
          align: "center",
          noSetText: "未设置",
          
        },
        {
          label: "关键字",
          prop: "keywordList",
          width: "160",
          align: "center",
          noSetText: "未设置",
          isTagArr: true,
        },
        {
          label: "专业代码",
          prop: "majorCode",
          width: "140",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "报考形式",
          prop: "examinationStyle",
          width: "140",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "考试科目",
          prop: "examCourse",
          width: "300",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "专业描述",
          prop: "summary",
          width: "160",
          align: "center",
          noSetText: "未设置",
          isToMoreContents: true,
        },
        {
          label: "主修课程",
          prop: "majorCourses",
          width: "160",
          align: "center",
          noSetText: "未设置",
          isToMoreContents: true,
        },
        {
          label: "就业方向",
          prop: "jobOrientation",
          width: "160",
          align: "center",
          noSetText: "未设置",
          isToMoreContents: true,
        },
        {
          label: "创建时间",
          prop: "createTime",
          width: "200",
          align: "center",
          noSetText: "未设置",
        },
      ],
      //筛选项
      search: {
        name: "", //筛选 非普本类专业名称
        majorCategoryId: "", //筛选 专业类别
      },
      majorCategorySel: [], //专业类别下拉选项
      dialogTitle: "添加学历类专业",
      addEditVisible: false, //添加编辑弹窗
      editId: 0, //是否是编辑
      contentdialogTitle: "",
      contentVisible: false, //内容弹窗
      contentDetails: "", //内容
    });
    //挂载后调用函数获取项目数据
    onMounted(() => {
      getMajorCategoryList(); //获取专业类别
      getMarjorData(); //请求非普本类专业列表数据
    });

    //获取专业类别下拉
    function getMajorCategoryList() {
      getMajorCategory(false)
        .then((res) => {
          if (res.code == 1) {
            data.majorCategorySel = res.result;
            data.headerData.map((item) => {
              if (item.prop == "majorCategoryName") {
                item.selectOptions = [
                  {id:null,name:'所属专业类别(全部)'},
                  ...data.majorCategorySel
                ];
              }
            });
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 跳转前台对应课程详情页
    const UrlOpen = ref();
    const openCourseDetail = (item) => {
      ElMessageBox({
        title: "预览提示",
        message: h("p", null, [
          h("span", null, "查看专业 "),
          h("span", null, `[${item.name}]`),
          h("span", null, "详情，请选择打开端口 "),
        ]),
        showCancelButton: true,
        confirmButtonText: "打开电脑端",
        cancelButtonText: "打开移动端",
        customClass: "msgbox-custom",
        distinguishCancelAndClose: true, //该属性可区分用户点击的是cancel取消按钮，还是close关闭，设为false时默认均为cancel
      })
        .then((action) => {
          if (action === "confirm") {
            let name = "";
           if (item.categoryId == 11) {
              name = "/ckzsb/major/";
            } else if (item.categoryId == 10) {
              name = "/zkzsb/major/";
            }else if(item.categoryId == 51){
              name = "/gkzsb/major/";
            }
            window.open(
              'https://www.sbgw.cn' + name + item.id + ".html"
            );
          }
        })
        .catch((action) => {
          if (action === "cancel") {
            let name = "";
           if (item.categoryId == 11) {
              name = "/ckzsb/major/";
            } else if (item.categoryId == 10) {
              name = "/zkzsb/major/";
            }else if(item.categoryId == 51){
              name = "/gkzsb/major/";
            }
            var url =
              'https://m.sbgw.cn' + name + item.id + ".html";
            if (item.name && item.name != null && item.name != "") {
              data.UrlOpenFlag = true;
              data.selectTitle = "查看专业[" + item.name + "]详情";
              data.mobileUrl = url;
            }
          }
        });
    };
    // 获取列表
    const getMarjorData = () => {
      data.loading = true;
      const obj = {
        name: data.search.name || null,
        majorCategoryId: data.search.majorCategoryId || null,
        pageIndex: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
      };
      getMajorPageList(obj)
        .then((result) => {
          if (result && result.code == 1) {
            data.loading = false;
            const list = result.data;
            data.pagination.total = result.totalCount;
            data.tableData = list;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "name") {
        data.search.name = val.value;
      }
      if (val.prop && val.prop == "majorCategoryName") {
        data.search.majorCategoryId = val.value;
      }
      data.pagination.currentPage = 1;
      getMarjorData();
    };

    //更新列表
    const updateList = () => {
      getMarjorData();
    };

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };

    // 添加/编辑非普本类专业
    const addFnc = () => {
      data.addEditVisible = true;
      data.dialogTitle = "添加学历类专业";
      data.editId = 0;
    };

    // 编辑院校
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${data.multipleSelection[0].name}】专业`;
      data.editId = data.multipleSelection[0].id;
    };

    // 删除
    const deleteFnc = (obj) => {
      ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h("b", { style: "color: #fd5252;font-size:16px;" }, `${data.multipleSelection[0].name}`),
          h("span", null, "】专业？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            delMajor(data.multipleSelection[0].id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   deleteMarjor(obj.id);
        // })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteMarjor(id) {
      delMajor(id)
        .then((result) => {
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };

    //查看详情
    const openContent = (val) => {
      // console.log(val);
      // 就业方向弹窗
      if (val.prop == "jobOrientation") {
        data.contentdialogTitle = `查看【${val.value.name}】就业方向`;
        data.contentVisible = true;
        data.contentDetails = val.value.jobOrientation;
      }
      // 专业描述弹窗
      if (val.prop == "summary") {
        data.contentdialogTitle = `查看【${val.value.name}】专业描述`;
        data.contentVisible = true;
        data.contentDetails = val.value.summary;
      }
      // 主修课程弹窗
      if (val.prop == "majorCourses") {
        data.contentdialogTitle = `查看【${val.value.name}】主修课程`;
        data.contentVisible = true;
        data.contentDetails = val.value.majorCourses;
      }
    };
// 表格多选行处理
const handleSelection = (row) => {
  data.multipleSelection = JSON.parse(JSON.stringify(row));
};
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getMarjorData,
      searchFnc,
      updateList,
      addFnc,
      editFnc,
      deleteFnc,
      closeDialog,
      changePagination,
      openContent,
      openCourseDetail,
      UrlOpen,
      handleSelection,
      btnInTable,
      btnLeftList,
      buttonList,
      btnOnList,
      btnHandle,
      doEvent,
    };
  },
};
</script>
<style scoped>
/deep/table {
  border: 1px solid #333;
  border-collapse: collapse;
}
/deep/td {
  border: 1px solid #333;
  border-collapse: collapse;
}
</style>

